<template>
    <div>
        <div class="login-cont">
            <div class="cont-2">
                <div class="mode-switch" v-if="showMode && showMode.includes('switchMode')">
                    <p class="login-tip" @click="changeMode(loginMode == 1 ? 2 : 1)">
                        {{ loginMode == 1 ? '扫码登录' : '密码登录' }}
                    </p>
                    <i v-if="loginMode == 1" class="qrcode-ico" @click="changeMode(2)"></i>
                    <i v-if="loginMode == 2" class="win-ico" @click="changeMode(1)"></i>
                </div>
                <!--密码登录 验证码登录-->
                <div class="col-1" v-show="loginMode == 1">
                    <!--密码，验证码切换 头部-->
                    <div class="tips">
                        <p :class="{ selected: loginWay == 1 }" @click="changeWay(1)">
                            账号登录
                        </p>
                        <p class="line"
                            v-if="showMode && showMode.includes('byAccount') && showMode.includes('byCode')"></p>
                        <p v-if="showMode && showMode.includes('byCode')" :class="{ selected: loginWay == 2 }"
                            @click="changeWay(2)">
                            验证码登录
                        </p>
                    </div>
                    <!--表单-->
                    <div class="form-box">
                        <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form" @submit.native.prevent>
                            <el-form-item prop="userName" v-if="loginWay === 1">
                                <!-- <i class="label-txt el-icon-mobile-phone"></i> -->
                                <el-input type="text" v-model.trim="loginForm.userName" placeholder="请输入账号" clearable autocomplete="on">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="pwd" v-if="loginWay === 1">
                                <!-- <i class="label-txt el-icon-lock"></i> -->
                                <!--</el-input>-->
                                <el-input type="password" placeholder="请输入密码" v-model="loginForm.pwd" clearable
                                    autocomplete="on" show-password
                                    @keyup.native="passwordKeyup"
                                    @focus="passwordFocus">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="tel" v-if="loginWay === 2">
                                <!-- <i class="label-txt el-icon-mobile-phone"></i> -->
                                <el-input v-model.trim="loginForm.tel" placeholder="请输入手机号" maxlength="11" clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="code" v-if="loginWay === 2">
                                <!-- <i class="label-txt el-icon-lock"></i> -->
                                <el-input type="txt" class="padding-right" placeholder="请输入验证码" maxlength="6"
                                    v-model.trim="loginForm.code" clearable>
                                </el-input>
                                <el-button v-show="codeSta" 
                                    :class="{'get-code-btn': true, 'disabled': !loginForm.tel || !/^1[3456789]\d{9}$/.test(loginForm.tel)}"
                                    @click="getCode()">获取验证码</el-button>
                                <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s
                                </el-button>
                            </el-form-item>
                            <div class="rember" v-if="loginWay === 1">
                                <el-checkbox class="agree-deal" v-model="ischecked">记住密码
                                </el-checkbox>
                                <span class="find-pwd" @click="toFindPwd"
                                    v-if="showMode && showMode.includes('findPaw')">忘记密码</span>
                            </div>

                            <div class="login-btn">
                                <el-button v-if="loginWay === 1" class="submit-login-form" type="primary" native-type="submit"
                                    @click="submitForm('loginForm')" :disabled="!loginForm.userName || !loginForm.pwd">
                                    登录
                                </el-button>
                                <el-button v-if="loginWay === 2" class="submit-login-form" type="primary" native-type="submit"
                                    @click="submitForm('loginForm')" :disabled="!loginForm.tel || !loginForm.code">登录
                                </el-button>
                            </div>
                        </el-form>
                    </div>
                    <div>
                        <div class="err-txt" :class="{ 'has-cont': errTxt }">
                            <p>{{ errTxt }}</p>
                        </div>
                        <p class="to-register" v-if="showMode && showMode.includes('registe')" @click="toRegister">立即注册</p>
                    </div>
                    <!--第三方-->
                    <div class="line-box" v-if="showMode && showMode.includes('switchMode')">
                        <div class="line"></div>
                        <p>其他登录方式</p>
                        <div class="line"></div>
                    </div>
                    <div class="other" v-if="showMode && showMode.includes('switchMode')">
                        <div class="wx" @click="changeMode(2)">
                            <i class="wx-ico"></i>
                        </div>
                    </div>
                </div>
                <!-- 二维码登录 -->
                <div class="col-1" v-show="loginMode == 2">
                    <div class="qrcode-login">
                        <!-- <wxlogin 
                            :appid="wxQrcodeOptions.wxAppid" state="1211111" scope="snsapi_login" theme="black" 
                            :redirect_uri="encodeURIComponent(wxQrcodeOptions.wxRedirectUri)">
                        </wxlogin> -->
                    </div>
                    <div class="qrcode-bottom" v-if="showMode && showMode.includes('registe')">
                        <p>没有账号？<span @click="toRegister">立即注册</span></p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 密码错误超过5次提示dialog -->
        <el-dialog class="pop-tips" title="" :visible.sync="dialogVisible" width="20%" top="350px" center>
            <span class="tips-txt">密码错误，找回密码？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="toFindPwd">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 未绑定手机提示dialog -->
        <el-dialog class="bind-phone-tips" title="" :visible.sync="dialogVisible2" width="30%" top="350px" center>
            <div class="tips-con">
                <p><i class="tips-ico el-icon-warning"></i></p>
                <span class="tips-txt">该微信号暂未绑定手机号</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible2 = false">取 消</el-button> -->
                <el-button type="primary" class="dg-btn" @click="toBindPhone">立即绑定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import loginApi from '@/resources/loginModule/login'
export default {
    data: function () {
        // 验证用户名
        let checkUserName = (rule, value, callback) => {
            let reg = /^[0-9A-Za-z]{6,16}$/;
            if (!value) {
                return callback(new Error('请输入账号'));
            } else if (!reg.test(value)) {
                return callback(new Error('请输入6-16个字母开头的数字、字母'));
            } else {
                callback();
            }
        };
        // 验证手机号
        let checkTel = (rule, value, callback) => {
            let reg = /^1[3456789]\d{9}$/;
            if (!value) {
                return callback(new Error('请输入手机号'));
            } else if (!reg.test(value)) {
                return callback(new Error('请输入正确的手机号'));
            } else {
                callback();
            }
        };
        return {
            /*
            * showMode 展示模块，根据各业务传递的参数显示各功能模块，默认全部显示
            * switchMode切换登录方式(微信，账号)
            * byAccount 账号登录
            *  byCode 验证码登录
            *  registe 注册模块
            *  findPaw 找回密码
            * */
            showMode: ['byAccount', 'byCode', 'findPaw'],
            loginMode: 1, // 1 输入账号密码登录，2 二维码登录
            loginWay: 1, //登录方式: 1 账号登录， 2 验证码登录
            errTxt: '', //错误提示
            pasSta: false, //密码是否显示
            btnSta: false, //按钮是否可点击
            codeSta: true, //获取验证码按钮状态
            count: '',
            timer: null,
            //表单数据
            loginForm: {
                userName: '',
                pwd: '',
                tel: '',
                code: '',
            },

            //校验
            rules: {
                userName: [{ required: true, validator: checkUserName, trigger: 'blur' }],
                pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                tel: [{ required: true, validator: checkTel, trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
            dialogVisible: false,
            dialogVisible2: false,
            ischecked: false,
            wxCode: '',
            unionId: '',
            appId: 'eGtAX',
            originUrl: '',
            originPort: '',
            loginTip: '扫码登录',
            redirectUrl: '',
            siteName: '',
            wxQrcodeOptions: {
                wxAppid: '',
                wxRedirectUri: ''
            },
        };
    },
    created() {
        if (this.$route.query.code) {
            this.getOpenId(this.$route.query.code);
        }
        if (sessionStorage.loginMode) {
            this.loginMode = parseInt(sessionStorage.loginMode)
        }
        if (localStorage.userName && localStorage.userPwd) {
            this.ischecked = true;
        }
        sessionStorage.appId = 'eGtAX';
        sessionStorage.showMode = JSON.stringify(this.showMode);
    },
    mounted() {
        if (this.$route.query.from && this.$route.query.from === 'reg') {
            this.setWxerwma();
        }
        // 当刷新页面时候获取一下localStorage里存的值
        this.getlocalStorage();
    },
    methods: {
        setWxerwma() {
            this.wxQrcodeOptions = this.wxQrcodeOptions || JSON.parse(sessionStorage.wxQrcodeOptions || null);
        },
        changeMode(data) {
            this.loginMode = data;
            this.$refs.loginForm.clearValidate();
            if (data === 1) {
                this.loginTip = '扫码登录';
            } else {
                this.loginTip = '密码登录';
            }
            this.setWxerwma();
        },
        changeWay(data) {
            this.loginWay = data;
            this.$refs.loginForm.clearValidate();
            if (!this.ischecked) {
                this.resetForm('loginForm');
            }
        },
        changePwaSta() {
            this.pasSta = !this.pasSta;
        },
        getCode() {
            if (!/^1[3456789]\d{9}$/.test(this.loginForm.tel)) {
                return false;
            }
            this.sendMobileCode();
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.codeSta = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.codeSta = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.loginWay === 1) {
                        let para = {
                            loginName: this.loginForm.userName,
                            pwd: this.loginForm.pwd,
                        };
                        loginApi.loginByAccount(para).then((res) => {
                            if (res.returnCode === 200) {
                                let data = res.data;
                                // 传输数据到父页面
                                this.sendMessageToParent(data);
                                // 记住密码
                                if (this.ischecked == true) {
                                    this.setlocalStorage(
                                        this.loginForm.userName,
                                        this.loginForm.pwd
                                    );
                                } else {
                                    this.clearlocalStorage();
                                }
                            }
                        });
                    } else {
                        let para = {
                            mobile: this.loginForm.tel,
                            captcha: this.loginForm.code,
                        };
                        loginApi.loginByMobileCaptcha(para).then((res) => {
                            if (res.returnCode === 200) {
                                this.$message.success('登录成功');
                                // this.$router.push({ path: "/app/login" });
                                // 传输数据到父页面
                                let data = res.data;
                                this.sendMessageToParent(data);
                                console.log('childLoginForm:', this.loginForm);
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        sendMessageToParent(data) {
            // console.log(parent.location);
            try {
                window.parent.postMessage(data, parent.location.protocol + '//' + parent.location.host);
            } catch (error) {
                window.parent.postMessage(data, 'http://localhost:8114');
                window.parent.postMessage(data, 'https://sms.gtafe.com');
            }
        },
        //发送验证码
        sendMobileCode() {
            const appId = sessionStorage.appId;
            let para = {
                appId: appId,
                mobile: this.loginForm.tel,
                operationFlag: 3, //1.注册 2.忘记密码 3.登录 4.绑定手机号
            };
            loginApi.sendMobileCode(para).then((res) => {
                if (res.returnCode === 200) {
                    console.log('返回信息：', res);
                }
            });
        },
        // 根据code获取openId
        getOpenId(data) {
            let para = {
                code: data,
                appId: sessionStorage.appId,
            };
            loginApi.getOpenId(para).then((res) => {
                if (res.returnCode === 200) {
                    this.unionId = res.data;
                    this.wxLogin();
                }
            });
        },
        // 微信登录
        wxLogin() {
            let para = {
                unionId: this.unionId,
            };
            loginApi.wxLogin(para).then((res) => {
                if (res.returnCode === 200) {
                    this.$message.success('登录成功');
                    // 传输数据到父页面
                    this.sendMessageToParent(res.data);
                } else {
                    this.$router.push({
                        path: '/web/bindphone',
                        query: { unionId: this.unionId },
                    });
                }
            });
        },

        //设置用户名和密码
        setlocalStorage(c_name, c_pwd) {
            localStorage.userName = c_name;
            localStorage.userPwd = c_pwd;
        },
        //获取用户名和密码
        getlocalStorage() {
            for (let i = localStorage.length - 1; i >= 0; i--) {
                if (localStorage.key(i) == 'userName') {
                    this.loginForm.userName = localStorage.getItem(localStorage.key(i));
                }
                if (localStorage.key(i) == 'userPwd') {
                    this.loginForm.pwd = localStorage.getItem(localStorage.key(i));
                }
            }
        },
        //点击忘记密码，清除localStorage里的存储
        clearlocalStorage() {
            this.setlocalStorage('', '');
        },
        toRegister() {
            this.$router.push('/web/registe');
        },
        toFindPwd() {
            this.$router.push({ path: '/web/findpassword?gptLogin=1' });
        },
        bindPhoneTips() {
            this.dialogVisible2 = true;
        },
        toBindPhone() {
            this.dialogVisible2 = false;
            this.$router.push({ path: '/web/bindphone' });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 密码框光标置尾
        passwordFocus(e) {
            let obj = e.target;
            obj.selectionStart = obj.value.length;
            obj.focus();
        },
        passwordKeyup(e) {
            let obj = e.target;
            obj.value = obj.value.replace(/[\u4E00-\u9FA5]/g,'')
        }
    },
    watch: {
        '$route.query.code'(val) {
            if (val) {
                this.getOpenId(val);
            }
        },
    },
};
</script>

<style scoped>
@import "../../../assets/css/login/login.css";
</style>
